export const WIDGET_INIT_TTL_MS = 45 * 60 * 1000;

type WidgetInitCacheEntry = {
  token: string;
  apiBase: string;
  expiresAt: number;
};

const widgetInitCache = new Map<string, WidgetInitCacheEntry>();

export function getWidgetInitCacheKey(args: {
  storeId: string;
  mode: "dev" | "prod";
  initUrl: string;
}): string {
  return `${args.storeId}|${args.mode}|${args.initUrl}`;
}

export function getCachedWidgetInit(key: string): { token: string; apiBase: string } | null {
  const cached = widgetInitCache.get(key);
  if (!cached) return null;
  if (cached.expiresAt <= Date.now()) {
    widgetInitCache.delete(key);
    return null;
  }
  return { token: cached.token, apiBase: cached.apiBase };
}

export function setCachedWidgetInit(
  key: string,
  token: string,
  apiBase: string,
  ttlMs: number = WIDGET_INIT_TTL_MS
): void {
  if (!token || !apiBase) return;
  widgetInitCache.set(key, {
    token,
    apiBase,
    expiresAt: Date.now() + ttlMs,
  });
}
